<template>
  <div class="detail">
    <mu-container>
      <mu-card style="width: 100%; margin: 0 auto; padding: 0px">
        <van-cell-group title="基本信息">
          <van-notice-bar
            color="#1989fa"
            background="#ecf9ff"
            left-icon="clock-o"
            class="notice-swipe"
            v-if="flow.status == 0"
          >
            审批单状态：待审核
          </van-notice-bar>
          <van-notice-bar
            color="#67c23a"
            background="#f0f9eb"
            left-icon="passed"
            class="notice-swipe"
            v-else-if="flow.status == 1"
          >
            审批单状态：已审核通过
          </van-notice-bar>
          <van-notice-bar
            color="#f56c6c"
            background="#fef0f0"
            left-icon="close"
            class="notice-swipe"
            v-else-if="flow.status == 2"
          >
            审批单状态：已驳回
          </van-notice-bar>
          <van-notice-bar
            left-icon="replay"
            class="notice-swipe"
            v-else-if="flow.status == 5"
          >
            审批单状态：已撤销
          </van-notice-bar>
          <van-notice-bar
            color="#1989fa"
            background="#ecf9ff"
            left-icon="clock-o"
            class="notice-swipe"
            v-if="flow.is_pay == 0"
          >
            付款状态：未付款
          </van-notice-bar>
          <van-notice-bar
            color="#67c23a"
            background="#f0f9eb"
            left-icon="passed"
            class="notice-swipe"
            v-else-if="flow.is_pay == 1"
          >
            付款状态：已付款
          </van-notice-bar>
	  <van-notice-bar
            color="#67c23a"
            background="#f0f9eb"
            left-icon="passed"
            class="notice-swipe"
            v-else-if="flow.is_pay == 2"
          >
            付款状态：部分付款
          </van-notice-bar>
          <van-cell
            title="审批类型"
            :value="flow.catalog.title"
          />
          <van-cell title="申请编号" :value="flow.no" />
          <van-cell title="标题" :value="flow.title" />
          <van-cell title="费用说明" :value="flow.desc" />
          <van-cell title="附言" :value="flow.ps" />
          <!-- <van-cell title="合同编号" :value="flow.contract_no"/>
      <van-cell title="合同链接" :value="flow.contract_url" /> -->
          <van-cell title="附件" />
          <lazy-component>
          <div
            class="img_box"
            v-for="(file, index) in flow.filelist"
            :key="index"
          >
            <van-image
              v-if="type(file) == 'image'"
              width="10rem"
              height="10rem"
              fit="contain"
              :src="'http://caiwuapi.itkeen.net/'+file"
              @click="getImg(index)"
              
            />
            <a :href="'http://caiwuapi.itkeen.net/'+file" v-else-if="type(file) == 'pdf'"
              ><van-image
                width="4rem"
                height="4rem"
                fit="contain"
                src="/images/filesicon/pdf.png"
            /></a>
            <a :href="'http://caiwuapi.itkeen.net/'+file" v-else-if="type(file) == 'excel'"
              ><van-image
                width="4rem"
                height="4rem"
                fit="contain"
                src="/images/filesicon/xls.png"
            /></a>
            <a :href="'http://caiwuapi.itkeen.net/'+file" v-else-if="type(file) == 'word'"
              ><van-image
                width="4rem"
                height="4rem"
                fit="contain"
                src="/images/filesicon/docx.png"
            /></a>
            <a :href="'http://caiwuapi.itkeen.net/'+file" v-else-if="type(file) == 'zip'"
              ><van-image
                width="4rem"
                height="4rem"
                fit="contain"
                src="/images/filesicon/zip.png"
            /></a>
            <a :href="'http://caiwuapi.itkeen.net/'+file" v-else-if="type(file) == 'rar'"
              ><van-image
                width="4rem"
                height="4rem"
                fit="contain"
                src="/images/filesicon/rar.png"
            /></a>
          </div>
          </lazy-component>
          <AddFliles :flow_id="flow.id" @add_success="add_success()" />
        </van-cell-group>

        <van-cell-group title="申请人信息">
          <van-cell title="姓名" :value="flow.name" />
          <van-cell title="部门" :value="flow.department" />
          <van-cell title="职位" :value="flow.position" />
        </van-cell-group>
        <van-cell-group title="付款信息">
          <van-cell title="付款单位" :value="flow.payer" />
          <van-cell title="收款户名" :value="flow.payee" />
          <van-cell title="开户银行" :value="flow.bank" />
          <van-cell title="收款账号" :value="flow.bank_account" />
          <van-cell title="付款方式" :value="flow.payment_term" />
        </van-cell-group>
        <van-cell-group title="费用归集及分摊"></van-cell-group>
        <van-cell-group v-for="(cost, i) in flow.costs" :key="cost.id">
          <van-row class="account_top">
            <van-col span="24">
              <span class="no">0{{ i + 1 }}</span>
            </van-col>
          </van-row>
          <van-cell title="成本中心" :value="cost.cost_center" />
          <van-cell title="费用科目" :value="cost.cost_account" />
          <van-cell title="分摊金额" :value="cost.amount + '元'" />
          <van-cell title="计划预算" :value="cost.budget + '元'" />
          <van-cell title="已用预算" :value="cost.budget_used + '元'" />
          <van-cell title="申请中预算" :value="cost.budget_applying + '元'" />
        </van-cell-group>
        <van-cell-group title="总计">
          <van-cell
            title="付款金额"
            :value="flow.amount + '元'"
            value-class="amount"
          />
          <van-cell title="金额大写" :value="flow.amount_word" />
        </van-cell-group>
        <Comment :flow="flow" :flow_id="flow_id" :users="users"></Comment>
        <Approver :flow="flow" :users="users"></Approver>
        <CopyTo :flow="flow" :users="users"></CopyTo>
        <Action :flow="flow" :printObj="printObj" :users="users"></Action>
        <!-- <div v-else>
    <van-row class='bottom'>
        <van-col span="24">
            <van-notice-bar
              :scrollable="false"
              left-icon="volume-o"
              text="该申请已经被撤回。"
            />
        </van-col>
      </van-row>

  </div> -->
      </mu-card>
    </mu-container>
  </div>
</template>

<script>
// @ is an alias to /src
import CopyTo from "../../components/detail/CopyTo.vue";
import { fileType } from "../../assets/js/fileType.js";
import Action from "../../components/detail/Action.vue";
import Approver from "../../components/detail/Approver.vue";
import Comment from "../../components/detail/Comment.vue";
import AddFliles from "../../components/detail/AddFiles.vue";
import { ImagePreview } from "vant";

export default {
  name: "Home",
  components: { CopyTo, Action, Approver, Comment, AddFliles },
  data() {
    return {
      code: "",
      local: window.location.href,
      flow_id: this.$route.params.id,
      flow: {
        catalog: {},
      },
      flowForm: {
        comment: "",
        flow_id: this.$route.params.id,
      },
      active: 0,
      printObj: {
        id: "printMe",
        popTitle: "",
        extraCss: "",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
      },
      users:{},
    };
  },
  created() {
    // this.getCode();
    // console.log(this.$route.query)
    document.title = "审批单详情";
    // this.getCode();
    this.getdetail();
  },
  methods: {
    add_success() {
      this.getdetail();
    },
    getCode() {
      this.code = this.$route.query.code;
      //var code = getUrlParam('code');// 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      console.log(this.code);
      if (this.code == null || this.code == "" || this.code == "undefined") {
        console.log(3);
        //window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+APPID+'&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=#wechat_redirect';
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wwc4c076f1a1d9ecb4&redirect_uri=" +
          encodeURIComponent(this.local) +
          "&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
        return false;
      } else {
        this.getToken(); //把code传给后台获取用户信息
        return false;
      }
    },
    getToken() {
      this.$http.post("get_token", { code: this.code }).then((res) => {
        console.log(res);
        localStorage.token = res.data.data.token;
      });
    },
    getdetail() {
      this.$http.get("/flow/" + this.flow_id).then((res) => {
        console.log(res);
        if (res.data.code == 204) {
          this.$router.push({ name: "Login" });
          return false;
        }
        if (res.data.code != 200) {
          console.log(res.data.msg);
        }
        // if(res.data.data.role == 0){
        //   this.$dialog.alert({
        //     message: '你没有权限查看此审批',
        //   }).then(() => {
        //     this.$router.push({
        //     name: 'Home',
        //     })
        //   });
        // }
        this.flow = res.data.data;

        // console.log(this.flow)
      });
    },
    approve() {
      this.$http.post("/flow/approve", this.flowForm).then((res) => {
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          });
          return false;
        }
        this.$dialog
          .alert({
            message: res.data.msg,
          })
          .then(() => {
            this.$router.push({ name: "MyApproval" });
          });
      });
    },
    refuse() {
      this.$http.post("/flow/refuse", this.flowForm).then((res) => {
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          });
          return false;
        }
        this.$dialog
          .alert({
            message: res.data.msg,
          })
          .then(() => {
            this.$router.push({ name: "MyApproval" });
          });
      });
    },
    recall() {
      this.$http.post("/flow/recall", this.flowForm).then((res) => {
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          });
          return false;
        }
        this.$dialog
          .alert({
            message: res.data.msg,
          })
          .then(() => {
            this.$router.push({ name: "MyApproval" });
          });
      });
    },
    type(file) {
      return fileType(file);
    },
    getImg(index) {
      var files= [];
      this.flow.filelist.forEach(function(item,index){
        files.push('http://caiwuapi.itkeen.net/'+item)
      })
      ImagePreview({
        images: files, // 预览图片的那个数组
        showIndex: true,
        loop: false, //循环播放
        startPosition: index, // 指明预览第几张图
        showIndicators:true,//是否显示轮播指示器
        closeable:true, //是否显示关闭图标
      });
    },
  },
};
</script>
<style scoped>
.account_top {
  border-left: #42b983 5px solid;
  height: 45px;
  border-bottom: #eee 1px solid;
}
.account_top .no {
  margin: 10px 5px;
  font-weight: bold;
  color: #42b983;
  float: left;
  padding-top: 5px;
}
.van-cell-group__title {
  background-color: #3f51b5;
  font-size: 14px;
  font-weight: blod;
  color: white;
  padding: 13px;
}
.van-cell__title {
  text-align: left;
}
h3 {
  font-size: 12px;
  margin: 5px;
}
p {
  margin: 0px;
  font-size: 12px;
}
.bottom {
  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 80px;
  z-index: 99;
  padding: 10px 0px 30px 0px;
  background-color: white;
}
.van-notice-bar {
  padding: 10px 0;
  margin-top: 10px;
}

.amount {
  font-weight: bold;
  color: red;
}
.notice-swipe {
  font-weight: 600;
  padding-left: 10px;
}
.img_box {
  display: inline-block;
}
</style>
